<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
/* Optional: global styles */
@import '~@fortawesome/fontawesome-free/css/all.css';

body {
  margin: 0;
  font-family: Arial, sans-serif;
}

#app {
  background-image: url('~@/assets/body-bg.64b69828.jpg');
  background-size: cover;
  background-position: center;
  min-height: 100vh;
  color: white; /* Ensures text is visible on the dark background */
}
</style>
